/**
 * Mega Menu Collapsible Columns Functionality
 */
(function () {
  "use strict";

  const initMegaCollapsible = () => {
    const collapsibles = document.querySelectorAll('.hdt-mega-collapsible');

    collapsibles.forEach(container => {
      const isMobile = window.innerWidth < 768;
      const defaultState = container.getAttribute('data-default-state') || 'open';
      const triggers = container.querySelectorAll('.hdt-collapsible-trigger');

      triggers.forEach(trigger => {
        const column = trigger.closest('.hdt-collapsible-column');
        const content = column.querySelector('.hdt-collapsible-content');

        if (!column || !content) return;

        // Prevent multiple listeners
        if (trigger.dataset.initialized) return;
        trigger.dataset.initialized = "true";

        trigger.addEventListener('click', (e) => {
          const isMobile = window.innerWidth < 768;
          const defaultState = container.getAttribute('data-default-state') || 'open';

          // If desktop and not set to closed by default, behave normally (allow link navigation)
          if (!isMobile && defaultState === 'open') return;

          // Prevent multiple clicks during transition
          if (column.dataset.transitioning === "true") return;

          // Otherwise, handle as toggle and prevent navigation
          e.preventDefault();
          e.stopPropagation();

          const isCollapsed = column.getAttribute('data-collapsed') === 'true';

          if (isCollapsed) {
            expand(column, content);
          } else {
            collapse(column, content);
          }
        });

        // Set initial state
        const isCollapsed = column.getAttribute('data-collapsed') === 'true';
        if (isCollapsed) {
          content.style.display = 'none';
          content.style.height = '0';
          content.style.opacity = '0';
          content.style.overflow = 'hidden';
        } else {
          content.style.display = 'block';
          content.style.height = 'auto';
          content.style.opacity = '1';
          content.style.overflow = 'visible';
        }
      });
    });
  };

  const expand = (column, content) => {
    column.dataset.transitioning = "true";
    content.style.display = 'block';
    content.style.height = '0px';
    content.style.opacity = '0';
    content.offsetHeight; // force reflow

    const height = content.scrollHeight + 'px';
    content.style.height = height;
    content.style.opacity = '1';
    column.setAttribute('data-collapsed', 'false');

    const onEnd = (e) => {
      if (e.propertyName === 'height') {
        content.style.height = 'auto';
        content.style.overflow = 'visible';
        column.dataset.transitioning = "false";
        content.removeEventListener('transitionend', onEnd);
      }
    };
    content.addEventListener('transitionend', onEnd);
  };

  const collapse = (column, content) => {
    column.dataset.transitioning = "true";
    content.style.overflow = 'hidden';
    const height = content.scrollHeight + 'px';
    content.style.height = height;
    content.offsetHeight; // force reflow

    content.style.height = '0px';
    content.style.opacity = '0';
    column.setAttribute('data-collapsed', 'true');

    const onEnd = (e) => {
      if (e.propertyName === 'height') {
        content.style.display = 'none';
        content.style.height = '0';
        content.style.opacity = '0';
        column.dataset.transitioning = "false";
        content.removeEventListener('transitionend', onEnd);
      }
    };
    content.addEventListener('transitionend', onEnd);
  };

  // Run on load and whenever mega menu might be dynamically loaded/opened
  document.addEventListener('DOMContentLoaded', initMegaCollapsible);

  // For Shopify design mode
  document.addEventListener('shopify:section:load', initMegaCollapsible);
  document.addEventListener('shopify:block:select', initMegaCollapsible);

  // Kalles might lazy load submenus, so we need to watch for those
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1 && (node.classList.contains('hdt-mega-collapsible') || node.querySelector('.hdt-mega-collapsible'))) {
            initMegaCollapsible();
          }
        });
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  window.addEventListener('resize', () => {
    initMegaCollapsible();
  });

})();
